// extracted by css-extract-rspack-plugin
export default {"scrollable":"DashboardAlertsList_scrollable___ur9f","header":"DashboardAlertsList_header__gfmih"};